// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"4b0c8067","238":"b4643d16","453":"ebbe8d83","947":"a4b1b555"}[chunkId] + ".chunk.js";
};